import styled from 'styled-components';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
import { button } from '../styles/fonts';
import { StyledLinkV2 } from '../styles/ui';
import { HEADER_TYPE } from '../types';
export const CustomNav = styled.nav `
  display: none;

  @media (min-width: ${breakpointLG}) {
    display: ${({ $type }) => ($type === HEADER_TYPE.Integrated ? 'none' : 'block')};
  }
`;
export const CustomList = styled.ul `
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style-type: none;
`;
export const CustomLink = styled(StyledLinkV2) `
  ${button};
  color: ${Colors.grey900};
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid transparent;

  &.background {
    background-color: rgb(48 150 255 / 24%);

    &:active {
      background-color: ${Colors.white};
      border: 2px solid ${Colors.blue300};
    }
  }
`;
export const CustomListItem = styled.li `
  display: flex;
  align-items: center;
  margin-right: 8px;

  &:last-of-type {
    margin-right: 0;
  }

  .MuiButton-root.avatarButton {
    margin-left: 16px;

    &:hover {
      background-color: transparent;
    }
  }

  .avatarName {
    height: 48px;
    width: 48px;
    color: ${Colors.grey900};
    background-color: ${Colors.white};
    border: 1px solid ${Colors.cream100};
    border-radius: 8px;
    box-sizing: border-box;
    ${button};
  }

  .arrowDown {
    height: 24px;
    margin-left: 8px;
    color: ${Colors.black80};
    transition: transform 0.2s ease-in-out;
    transform-origin: center;
  }

  .rotateArrowDown {
    transform: rotate(-180deg);
  }
`;
export const CustomBadge = styled(Badge) `
  .MuiBadge-badge {
    right: -8px;
  }
`;
export const CustomBox = styled(Box) `
  display: flex;
  column-gap: 16px;
  align-items: center;
`;
export const AvatarWrapper = styled(Button) `
  &:focus,
  &:active {
    background-color: ${Colors.white};
    border: 2px solid ${Colors.blue300};
  }
`;
//# sourceMappingURL=styles.js.map